'use client';

import type { OfferCountdown } from '@workspace/ui/hooks/use-offer-countdown';
import { cn } from '@workspace/ui/lib/utils';

const pad = (value: number) => String(value).padStart(2, '0');

export function OfferCountdownTimer({
  countdown,
  className,
  hideSecondsOnMobile = false,
}: {
  countdown: OfferCountdown;
  className?: string;
  hideSecondsOnMobile?: boolean;
}) {
  const { days, hours, minutes, seconds, phase } = countdown;
  const units = [
    [days, 'd'],
    [hours, 'h'],
    [minutes, 'm'],
    [seconds, 's'],
  ] as const;

  return (
    <span
      role="timer"
      aria-label={`${days} days ${hours} hours ${minutes} minutes ${seconds} seconds left`}
      className={cn(
        'inline-flex items-baseline gap-1 font-mono font-medium tabular-nums',
        phase === 'last_call' ? 'text-offer-digits-urgent' : 'text-white',
        className,
      )}
    >
      {units.map(([value, unit]) => (
        <span
          key={unit}
          aria-hidden="true"
          className={cn(
            phase === 'last_call' && unit === 's' && 'animate-offer-beat',
            hideSecondsOnMobile && unit === 's' && 'max-md:hidden',
          )}
        >
          {pad(value)}
          <span className="text-[0.85em] opacity-60">{unit}</span>
        </span>
      ))}
    </span>
  );
}

export function OfferDiscountChip({
  discountPercent,
  urgent,
  className,
}: {
  discountPercent: number;
  urgent?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-md px-2 py-0.5 text-xs font-bold tracking-wide text-offer-ink',
        urgent ? 'bg-offer-amber' : 'bg-offer-gold',
        className,
      )}
    >
      {discountPercent}% off
    </span>
  );
}
